export const powerFiveConferencesIds = [2, 3, 4, 6, 9, 10];
export const groupFiveConferencesIds = [1, 5, 7, 8, 11, 91];
export const classYearClaimCutoff = new Date().getFullYear() - 6;
